import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }

  span {
    font-size: 16px;
    color: ${Tokens.ColorTextSecondary};
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-bottom: 40px;
`

export const ColumnWrapper = styled.div`
  flex: 1;
  min-width: 0;
  height: 80vh;
  max-height: 800px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const VerticalDivider = styled.div`
  width: 2px;
  background-color: ${Tokens.ColorBackgroundTertiary};
  align-self: stretch;
`

export const Title = styled.h2`
  color: ${Tokens.ColorTextPrimary};
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`

export const Subtitle = styled.h3`
  color: ${Tokens.ColorTextPrimary};
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 16px 0;
  text-decoration: underline;
`

export const SectionTitle = styled.h4`
  color: ${Tokens.ColorTextPrimary};
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0 12px 0;
`

export const Description = styled.p`
  color: ${Tokens.ColorTextSecondary};
  font-size: 14px;
  margin: 0 0 16px 0;
`

export const TableContainer = styled.div`
  margin: 16px 0;
  border-radius: ${Tokens.RadiusInput};
  overflow: hidden;
`

export const CenaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 42px;
`

export const CenaHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
`

export const CenaTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }

  span {
    font-size: 16px;
    color: ${Tokens.ColorTextSecondary};
  }
`

export const StickyTitleContainer = styled.div`
  position: sticky;
  top: 0;
  background-color: ${Tokens.ColorWhite};
  border-bottom: 2px solid ${Tokens.ColorUIPrimary};
  z-index: 10;
  padding: 16px 0 12px 0;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${Tokens.ColorBackground};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Tokens.ColorBorder};
    border-radius: 3px;

    &:hover {
      background: ${Tokens.ColorTextTertiary};
    }
  }
`
